var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.color,"label":""}},[_vm._v(_vm._s(_vm.$t(("common.roles." + _vm.normalizedRole))))])}
var staticRenderFns = []

export { render, staticRenderFns }